
import { Component, Vue } from 'vue-property-decorator';

import { State, Getter, Action } from '../utils/decorators';

@Component({ data: () => ({ publicPath: process.env.BASE_URL }) })
export default class Home extends Vue {

  @State() currentDay;
  @State() timerRunning;

  @State('userAgent') UA;

  @Getter() deromanized;
  @Getter() season;
  @Getter() nextSeason;
  @Getter() daysTillNextSeason;
  @Getter() daysTillWinter;
  // Timer getters
  @Getter() timeOfDay;
  @Getter() daytimeCountdown;
  @Getter() dayCountdown;
  @Getter() elapsedDayPercentage;

  @Action() changeDay;
  // Timer Actions
  @Action() initTimer;
  @Action() startTimer;
  @Action() pauseTimer;
  @Action() stopTimer;
  @Action() resetTimer;

  @Action() toggleAOD;


  created() {
    this.initTimer();
  }
}
